import type { RoleId } from '@onuw/roles-data'
import { ALIEN_GUIDES } from './alien'
import { BASE_GUIDES } from './base'
import { BONUS_GUIDES } from './bonus'
import { DAYBREAK_GUIDES } from './daybreak'
import type { RoleGuide } from './types'
import { VAMPIRE_GUIDES } from './vampire'

export type { RoleGuide } from './types'

/** Every role's page text. The type fails when a role has none. */
export const ROLE_GUIDES: Record<RoleId, RoleGuide> = {
  ...BASE_GUIDES,
  ...DAYBREAK_GUIDES,
  ...BONUS_GUIDES,
  ...VAMPIRE_GUIDES,
  ...ALIEN_GUIDES,
}
